export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="scroll-mt-24 bg-[#F7F5F0] py-24 md:py-40"
    >
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-3 reveal">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#5C5C58]">
            (01) · Who we are
          </span>
          <div className="mt-6 w-12 h-px bg-[#1C1C19]" />
        </div>

        <div className="md:col-span-9 reveal">
          <h2
            data-testid="about-headline"
            className="font-display text-4xl sm:text-5xl lg:text-7xl font-light tracking-tight leading-[1.05] text-[#1C1C19]"
          >
            A firm built at the
            <br />
            intersection of
            <span className="italic text-[#E26D5C]"> brand,</span>{" "}
            <span className="italic text-[#729B79]">creative</span>
            <br />
            and <span className="highlight-stroke">growth.</span>
          </h2>

          <div className="mt-14 grid md:grid-cols-2 gap-10 max-w-5xl">
            <p className="text-lg font-light leading-relaxed text-[#1C1C19]/80">
              Most agencies look at media spend. We look at brands: at
              what makes a customer choose one shelf over another, what
              keeps a community loyal over years, and what turns a
              founder's obsession into a category-defining business.
            </p>
            <p className="text-lg font-light leading-relaxed text-[#1C1C19]/80">
              GroundWork partners with founders and leadership teams to
              understand what needs to change, decide what to do next, and build
              what comes after. We bring brand, growth and creative thinking
              together around the problem, rather than starting with a
              predefined service.
            </p>
          </div>

          {/* Stats */}
          <div
            data-testid="about-stats"
            className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 border-t border-[#D8D4C7] pt-11"
          >
            {[
              { k: "Brand-grounded", v: "Positioning comes before any spend decision" },
              { k: "Founder-aligned", v: "We work as partners, not vendors" },
              { k: "Every sector", v: "Consumer, B2B, tech; no category off-limits" },
              { k: "Worldwide", v: "Partnering with brands across the globe" },
            ].map((s) => (
              <div key={s.k} className="reveal">
                <div className="font-display text-3xl sm:text-4xl lg:text-6xl text-[#1C1C19] font-light tracking-tight break-words">
                  {s.k}
                </div>
                <div className="mt-3 text-sm text-[#5C5C58] uppercase tracking-widest">
                  {s.v}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
